import { type ReactNode, useState } from "react";
import { useSettings } from "../settings/SettingsProvider";
import { SettingsPanel } from "../settings/SettingsPanel";
import { Footer } from "./Footer";
import { MobileBottomNav } from "./MobileBottomNav";
import { Navbar } from "./Navbar";

export function AppShell({ route, children }: { readonly route: string; readonly children: ReactNode }) {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const { settings } = useSettings();

  return (
    <>
      <Navbar route={route} locale={settings.locale} onOpenSettings={() => setSettingsOpen(true)} />
      <main id="main-content">{children}</main>
      <MobileBottomNav route={route} locale={settings.locale} />
      <Footer locale={settings.locale} />
      <SettingsPanel open={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </>
  );
}
